import { isVarTrue } from '@bluetrino/kamiokash-utils';

export const baseUrl = process.env.NEXT_PUBLIC_VERCEL_URL
  ? `https://${process.env.NEXT_PUBLIC_VERCEL_URL}`
  : 'http://localhost:3000';

export const NODE_ENV = process.env.NODE_ENV;

export const TARGET_ENV = process.env.NEXT_PUBLIC_VERCEL_TARGET_ENV;

export const SITE_NAME = 'KamioKash XP';
export const TWITTER_SITE = process.env.TWITTER_SITE!;
export const TWITTER_CREATOR = process.env.TWITTER_CREATOR!;

export const GTM_ID = process.env.GTM_ID ?? 'GTM-54FQ994V';

export const TURNSTILE_SITEKEY = process.env.NEXT_TURNSTILE_SITEKEY;

export const IS_SIGNUP_DISABLED = isVarTrue(process.env.SIGNUP_DISABLED);
export const IS_PHONE_ENABLED = isVarTrue(process.env.IS_PHONE_ENABLED);

export const CMS_BUCKET = 'cms';
export const PRIVATE_BUCKET = 'private';

export const IS_LOCAL_ENV = NODE_ENV === 'development';

export const IS_COMMS_ENABLED = isVarTrue(process.env.IS_COMMS_ENABLED);
export const IS_CONSOLE_ADAPTER_DISABLED = isVarTrue(process.env.CONSOLE_ADAPTER_DISABLED);

export const LOG_LEVEL = process.env.NEXT_PUBLIC_LOG_LEVEL ?? 'info';

export const IS_COMMUNICATIONS_WORKFLOW_ENABLED = isVarTrue(process.env.ENABLE_VERCEL_WORKFLOW);
